import { CLOSED_ACCESS_KEY_MAX_LENGTH } from '@guildrise/shared';
import { useState } from 'react';
import { Icon } from '../shared/ui/icons.js';
import './closed-access.css';

export function ClosedAccessScreen({
  busy,
  message,
  onUnlock,
}: {
  readonly busy: boolean;
  readonly message: string;
  readonly onUnlock: (key: string) => void;
}): React.ReactElement {
  const [key, setKey] = useState('');
  return (
    <main className="closed-access">
      <form
        className="closed-access__panel"
        onSubmit={(event) => {
          event.preventDefault();
          if (busy || key.length === 0) return;
          onUnlock(key);
          setKey('');
        }}
      >
        <span className="closed-access__crest">
          <Icon name="lock" size={25} />
        </span>
        <h1>GuildRise</h1>
        <p>Закрытый доступ</p>
        <label htmlFor="closed-access-key">Ключ приглашения</label>
        <input
          id="closed-access-key"
          type="password"
          autoComplete="off"
          autoCapitalize="none"
          spellCheck={false}
          maxLength={CLOSED_ACCESS_KEY_MAX_LENGTH}
          required
          value={key}
          disabled={busy}
          aria-describedby={message ? 'closed-access-error' : undefined}
          onChange={(event) => setKey(event.currentTarget.value)}
        />
        <p id="closed-access-error" className="closed-access__error" role="status">
          {message}
        </p>
        <button type="submit" disabled={busy || key.length === 0}>
          {busy ? 'Проверяем…' : 'Войти'}
        </button>
      </form>
    </main>
  );
}
